// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ProspectionsList    = lazy(() => import('../../views/prospections/list'))
const Prospections = [
  {
    
    path: '/prospections/list',
    element: <ProspectionsList />
  }
]

export default Prospections
